/**
 * @ngdoc module
 * @name flowingly.runner.exago
 * @module flowingly.runner.exago
 * @description This module configures the exago state.
 */
import angular from 'angular';

const m = angular.module('flowingly.runner.exago', ['flowingly.adapters']);
m.run([
  '$templateCache',
  function ($templateCache: angular.ITemplateCacheService) {
    $templateCache.put(
      'Client/runner.exago/runner.exago.tmpl.html',
      require('./runner.exago.tmpl.html').default
    );
  }
]);
